import { useContext, useEffect } from 'react'
import { ThemeContext } from './contexts/theme'
import Header from './components/Header/Header'
import About from './components/About/About'
// import Projects from './components/Projects/Projects'
// import Skills from './components/Skills/Skills'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Contact from './components/Contact/Contact'
// import Footer from './components/Footer/Footer'
import ScrollTicker from './components/ScrollTicker/ScrollTicker'
import Experience from './components/Experience/Experience'
// import CustomCursor from './components/CustomCursor/CustomCursor'
// import NewPortfolio from './components/NewPortfolio/NewPortfolio'
import './App.css'
import { useTranslation } from "react-i18next";
import AOS from 'aos';
import "aos/dist/aos.css"

const App = () => {

  const [{ themeName }] = useContext(ThemeContext);
  const { i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    setTimeout(() => AOS.refresh(), 50);
  }, [i18n.language]);

  return (
    <div id='top' className={`${themeName} app`}>
      {/* <CustomCursor /> */}
      <Header />

      <main>
        <About />
        <ScrollTicker />
        {/* <Experience /> */}
        <Contact />
      </main>

      <ScrollToTop />
      {/* <Footer /> */}
      {/* <NewPortfolio /> */}
    </div>
  )
}

export default App
